import * as React from 'react';
import { List, Paper, Typography } from '@mui/material';
import { Patient, Visit } from '../../../models/core';
import { PatientListItem } from '../../../components/PatientListItem';
import PatientListScaffold from './PatientListScaffold';
import {T as TEXT} from '../../i18n'

interface PatientsListProps {
    patients: (Patient & { visit?: Visit })[];
    onEdit?: (patient: Patient) => void;
    onAssign?: (patient: Patient) => void;
    onOpenVisits?: (patient: Patient) => void;
    loading?: boolean;
}

const PatientsList: React.FC<PatientsListProps> = ({
    patients,
    onEdit,
    onAssign,
    onOpenVisits,
    loading,
}) => {
    const patientList = React.useMemo(() => {
        return (patients || []).map((patient) => (
            <PatientListItem
                key={patient._id}
                patient={patient}
                visit={patient.visit || null}
                onOpenVisits={onOpenVisits}
                onEdit={onEdit}
                onAssign={onAssign}
            />
        ));
    }, [patients, onEdit, onAssign, onOpenVisits]);

    if (loading) {
        return <PatientListScaffold />;
    }
    
    if(patients?.length == 0) {
        return <Paper
            sx={{
                minHeight: '100%',
                maxHeight: '100%',
                overflow: 'auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            >
            <Typography>
                {TEXT('NO_PATIENTS_FILTER')}
            </Typography>
        </Paper>
    }

    return (
        <Paper style={{ minHeight: '100%', maxHeight: '100%', overflowY: 'auto' }}>
            <List>
                {patientList}
            </List>
        </Paper>
    );
};

export default PatientsList;